<template>
  <div>
    <b-card no-body>
      <b-tabs v-model="tabIndex" pills variant="info" class="nav-fill" card>
        <b-tab>
          <template slot="title">
            PENDING LOANS
          </template>
          <loans-infinite-table
            v-if="tabIndex === 0"
            group="in_progress"
            @total-loans-set="count = $event"
            @total-amount-set="amount = $event"
          />
        </b-tab>
        <b-tab>
          <template slot="title">
            ACTIVE LOANS
          </template>
          <loans-infinite-table
            v-if="tabIndex === 1"
            group="active"
            :format-function="activeCustomFormat"
            :captions="captions.active"
            @total-loans-set="count = $event"
            @total-amount-set="amount = $event"
            @action-clicked="deal => showActionModal(deal)"
          />
        </b-tab>
        <b-tab title=" PAID LOANS">
          <loans-infinite-table
            v-if="tabIndex === 2"
            group="paid"
            @total-loans-set="count = $event"
            @total-amount-set="amount = $event"
          />
        </b-tab>
        <b-tab title="ALL">
          <loans-infinite-table
            v-if="tabIndex === 3"
            group="all"
            @total-loans-set="count = $event"
            @total-amount-set="amount = $event"
          />
        </b-tab>
      </b-tabs>
    </b-card>
    <actions-modal ref="actionsModal" />
  </div>
</template>

<script>
import helper from '@/libs/helper';
import dealsHelper from '@/libs/deals';

import LoansInfiniteTable from '@/components/my_deals/deals/LoansInfiniteTable';
import ActionsModal from '@/components/my_deals/actions/ActionsModal';


/* eslint no-underscore-dangle: ["error", { "allow": ["_cellVariants"] }] */
export default {
  components: {
    LoansInfiniteTable,
    ActionsModal,
  },
  props: {
    category: String,
  },
  data: () => ({
    amount: 0,
    captions: {
      active: [
        { text: 'Draw > 90 days', background: '#ffdf80' },
        { text: 'Upcoming Maturity Date', background: '#ffeeba' },
        { text: 'Past Maturity Date', background: '#f5c6cb' },
      ],
    },
    count: 0,
    tabIndex: 0,
    categoryIndexMap: {
      in_progress: 0,
      active: 1,
      paid: 2,
      all: 3,
    },
  }),
  watch: {
    category() {
      this.updateTabIndex();
    },
    tabIndex() {
      const indexCategory = Object.keys(this.categoryIndexMap).find(
        key => this.categoryIndexMap[key] === this.tabIndex,
      );
      this.$emit('index-updated', this.tabIndex, indexCategory);
    },
    amount() {
      this.$emit('amount-updated', this.amount);
    },
    count() {
      this.$emit('count-updated', this.count);
    },
  },
  methods: {
    updateTabIndex() {
      const tab = this.categoryIndexMap[this.category];
      if (typeof tab === 'number') {
        this.tabIndex = tab;
      }
    },
    showActionModal(deal) {
      this.$refs.actionsModal.show(deal);
    },
    activeCustomFormat(loans) {
      /* eslint no-param-reassign: "error" */
      const today = new Date();
      const upcomingMaturity = maturityDate => helper.dayDiff(today, maturityDate) <= 30;

      return loans.map((loan) => {
        const hasOldDraws = dealsHelper.oldDrawsFilter(loan);
        const maturityDate = new Date(loan.maturity_date);
        const pastMaturity = dealsHelper.maturityFilter(loan) && maturityDate < today;
        const maturityUpcoming = upcomingMaturity(maturityDate);
        const shouldFormat = hasOldDraws || pastMaturity || maturityUpcoming;
        if (!shouldFormat) { return loan; }

        const maturityWarningClass = maturityUpcoming ? 'warning' : null;
        loan._cellVariants = {
          maturity_date: today < maturityDate ? maturityWarningClass : 'danger',
          draw_date: dealsHelper.oldDrawsFilter(loan) ? 'yellow' : null,
        };
        return loan;
      });
    },
  },
  mounted() {
    this.updateTabIndex();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/deals/LoanTablesContainer.vue